export default "__VITE_ASSET__BeHhfO_Q__"